module.exports = __webpack_public_path__ + "a4b801315fff1b7821c1ed9b886a46f1.svg";